module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Endpapers:")]), _vm._v(" The Coronation procession of King Edward VI. (Bridgeman Art Library: Society of Antiquaries)")]), _vm._v(" "), _c('ol', {
    staticClass: "ol-arabic"
  }, [_c('li', {
    staticClass: "listItem"
  }, [_vm._v("‘No painting ever boasted greater’: Hans Holbein’s mural of Henry VIII. (2006 HM Queen Elizabeth II)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("The image of royal supremacy. (Bridgeman Art Library: Thyssen-Bornemisza Collection, Madrid)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("The reality. (Bridgeman Art Library: Society of Antiquaries)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Jane Seymour. (Bridgeman Art Library: Kunsthistorisches Museum, Vienna)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("‘Little one, emulate thy father and be the heir of his virtue’. (AKG London: National Gallery of Art, Washington DC, Andrew Mellon Collection)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Henry was a devoted father to his son. (2006 HM Queen Elizabeth II)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Edward’s early childhood was one of carefree abandon. (AKG London: Kunstmuseum, Basel)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Henry Howard, Earl of Surrey. (National Portrait Gallery)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Edward at Ashridge House. (2006 HM Queen Elizabeth II)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Sir John Cheke. (Getty Images)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Allegory of Edward’s reign. (National Portrait Gallery)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Henry VIII’s last will and testament. (National Archives)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("William Paget, Henry VIII’s private secretary. (National Portrait Gallery)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Edward Seymour, Duke of Somerset and Edward’s uncle: portrait by Hans Holbein. (Bridgeman Art Library: Trustees of the Weston Park Foundation)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Edward’s signature. (Bridgeman Art Library)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Edward on the cusp of manhood. (AKG London: Louvre, Paris)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Princess Mary, Edward’s elder half-sister. (National Portrait Gallery)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("A teenage Princess Elizabeth, Edward’s half-sister. (2006 HM Queen Elizabeth II)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Katherine Parr, Henry VIII’s sixth wife. (National Portrait Gallery)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Sir Thomas Seymour, Somerset’s younger brother. (National Portrait Gallery)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Thomas Cranmer, Archbishop of Canterbury. (Bridgeman Art Library: Lambeth Palace)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("An allegory of Edward’s reign, from John Foxe’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Acts and Monuments")]), _vm._v(", 1570. (Bridgeman Art Library)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("John Dudley, later Duke of Northumberland. (W&N Archive)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Thomas Wriothesley, Earl of Southampton. (Private Collection)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("A woodcut from Foxe’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Acts and Monuments")]), _vm._v(" showing Hugh Latimer preaching. (Bridgeman Art Library)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("A seventeenth-century woodcut of the Duke of Somerset’s execution on Tower Hill. (W&N Archive)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("The frontispiece of the controversial 1549 Book of Common Prayer. (Bridgeman Art Library)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Edward VI opening Parliament in March 1553. (2006 HM Queen Elizabeth II)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Edward’s ‘devise for the succession’. (Inner Temple, Library)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Lady Jane Grey, Edward’s ill-fated cousin. (Bridgeman Art Library)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ac4523","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781466805798_fm01.vue
// module id = 69
// module chunks = 0